import useSWR from 'swr';
import { LicenseService } from '@/services/engine/license-service';
import type { LicenseStatus } from '@/types/license';

const CACHE_KEY = 'license-status';

export function useLicenseStatus() {
    const { data, isLoading, error, mutate } = useSWR<LicenseStatus>(
        CACHE_KEY,
        () => LicenseService.getStatus(),
        { revalidateOnFocus: false },
    );

    return { license: data, isLoading, error, mutate };
}
